import React, {useState, useEffect, useRef} from "react";
import "./Navbar.css";
import logo from "../../../assets/images/logo_navbar.png";
import UserIcon from "../../icons/UserIcon";
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { logout } from '../../../services/redux/authSlice';
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleUserIconClick = () => setDropdownOpen(!isDropdownOpen);
  
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const goToHome = () => {
    navigate('/');
  }

  const handleLogout = () => {
    dispatch(logout());
    toast.success('Volte sempre!');
    setDropdownOpen(false);
    goToHome();
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-container-itens">
            <div className="navbar-container-itens-logo" onClick={goToHome}>
                <img src={logo} alt="Santillana Educação" className="navbar-logo" />
            </div>
            <div className="navbar-container-itens-options">
            {
              isAuthenticated &&
                <div className="menu-options">
                    <div className="option-link" onClick={handleUserIconClick}>
                      <UserIcon/>
                      {isDropdownOpen && (
                        <div ref={dropdownRef} className={`navbar__dropdown ${isDropdownOpen ? "navbar__dropdown--open" : ""}`}>
                          <a href="/pedidos" className="option-link navbar__dropdown-item brighten-on-hover">Meus pedidos</a>
                          <a href="/perfil" className="option-link navbar__dropdown-item brighten-on-hover">Perfil</a>
                          <div onClick={handleLogout} className="option-link navbar__dropdown-item clickable brighten-on-hover">Sair</div>
                        </div>
                      )}
                    </div>
                </div>
            }
            </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
